// src/hooks/useAuth.js

import { useAuthentication } from "../context/AuthContext";

export function useAuth() {
  return useAuthentication();
}
